import { AutocompleteFactory } from "./components/autocomplete";
import { DropdownButtonFactory } from "./components/dropdown-button";
import { SliderFactory } from "./components/slider";
import { ComponentService } from "./core/component-service";
import { NotificationsService } from "./core/notifications-service";
import { TransitionService } from "./core/transitions";
import { ChartsService } from "./core/charts-service";

import "./charts/charts.js";  
 
let componentsService = new ComponentService();
let transitionService = new TransitionService();
let notifications = new NotificationsService();
let charts = new ChartsService();

componentsService.registerComponent("dropdown", DropdownButtonFactory);
componentsService.registerComponent("slider", SliderFactory);
componentsService.registerComponent("autocomplete", AutocompleteFactory)

declare global {
    interface Window {
      components: ComponentService;
      transitions: TransitionService;
      notifications: NotificationsService;
      charts: ChartsService;
    }
  }

window.components = componentsService;
window.transitions = transitionService;
window.notifications = notifications;
window.charts = charts;

console.log("SynapIoT Components INITIALIZED :-)");